/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const reviewerBreakdownItemSchema = z.object({
  reason: z.string(),
  count: z.number(),
});

export const reviewerPerformanceBreakdownV1DataSchema = z.object({
  userId: z.string(),
  reasons: z.array(reviewerBreakdownItemSchema),
});

export type IReviewerBreakdownItem = z.infer<typeof reviewerBreakdownItemSchema>;
export type IReviewerPerformanceBreakdownV1Data = z.infer<
  typeof reviewerPerformanceBreakdownV1DataSchema
>;

export const getReviewerPerformanceBreakdownV1ResponseSchema = createApiResponseSchema(
  reviewerPerformanceBreakdownV1DataSchema,
) as z.ZodSchema<IAPI<IReviewerPerformanceBreakdownV1Data>>;

export type IGetReviewerPerformanceBreakdownV1Response = IAPI<IReviewerPerformanceBreakdownV1Data>;
